import { useMemo } from 'react'

export type LcmChipDispatcher = (id?: string, title?: string) => void

// TODO(orbit-handler-missing): rail pin, hide, rename, and reset primitives do not exist yet.
export const useLcmChipDispatchers = (): Record<string, LcmChipDispatcher> =>
  useMemo(() => ({}), [])
